/// <reference path="../types/index.d.ts" />

import '../client_forms/boldamerican5/style.css';
import FormStructure from './boldamerican5/form_structure';

export default FormStructure;